<script setup lang="ts">
import type { ConfiguratorPoolStair } from '~/models/configurator/configuratorPoolStair.model'

interface Props {
  selectableStairs: ConfiguratorPoolStair[]
  shownStairs: ConfiguratorPoolStair[]
}
const props = defineProps<Props>()
const { t } = useI18n()
const { dt } = useDirectusTranslation()
const currentStair = defineModel<ConfiguratorPoolStair>({
  required: true,
})

function isSelectable(stair: ConfiguratorPoolStair): boolean {
  return props.selectableStairs.some(s => s.id === stair.id)
}

function onSelect(stair: ConfiguratorPoolStair) {
  if (isSelectable(stair))
    currentStair.value = stair
}

const ordenedStairs = computed(() => {
  const clonedStairs = props.selectableStairs.map(stair => ({
    ...stair,
  }))

  return clonedStairs.sort((a, b) => a.id - b.id)
})
</script>

<template>
  <div class="flex flex-col items-center gap-2">
    <h2 class="hidden text-3xl font-bold lg:block">
      {{ t('label.stair') }}
    </h2>
    <p class="mb-2 h-6 text-1.3rem">
      {{ dt(currentStair.translations)?.name }}
    </p>
    <div class="flex flex-wrap items-center justify-center gap-4">
      <AppButton
        v-for="stair in ordenedStairs"
        :key="stair.id"
        class="relative h-36 w-36 overflow-hidden bg-cover object-cover p-0 transition-all"
        :class="{
          'opacity-50': !isSelectable(stair),
        }"
        :is-disabled="!isSelectable(stair)"
        :is-active="currentStair.id === stair.id"
        @click="onSelect(stair)"
      >
        <AppDirectusImage
          :width="144"
          class="h-full bg-cover object-cover object-top !w-36"
          :image="stair.stairImage"
        />
      </AppButton>
    </div>
  </div>
</template>
